import { render, staticRenderFns } from "./PrimaryPhysician.vue?vue&type=template&id=7c6d93ea&scoped=true"
import script from "./PrimaryPhysician.vue?vue&type=script&lang=js"
export * from "./PrimaryPhysician.vue?vue&type=script&lang=js"
import style0 from "./PrimaryPhysician.vue?vue&type=style&index=0&id=7c6d93ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6d93ea",
  null
  
)

export default component.exports